import React from 'react';
import PageTop from '../../../core/components/PageTop';
import { PageTopBreadcrumb } from '../../../core/components/types';
import { CP_ORDER_INVOICES_ROUTE_LIST } from '../cp_order_invoices_const';
import { useOrdersCpOrderInvoicesDetailsInit } from './useOrdersCpOrderInvoicesDetailsInit';
import Panel from '../../../core/components/Panel';
import CpOrderInvoiceLineItemsTableList from './CpOrderInvoiceLineItemsTableList';
import { useInvoiceDetailsData } from './useInvoiceDetailsData';
import CpOrderInvoiceInformationPanel from './CpOrderInvoiceInformationPanel';
import { useAtomValue } from 'jotai';
import { cpOrderInvoicesDetailsPageStateAtom } from './cp_order_invoices_details_atoms';

const PageOrdersCpOrderInvoicesDetails = (): JSX.Element => {
    const { title } = useOrdersCpOrderInvoicesDetailsInit();
    const breadcrumb: PageTopBreadcrumb = {
        title: 'Return to CP Order Invoices List',
        icon: 'sprite-ce',
        route: CP_ORDER_INVOICES_ROUTE_LIST,
    };

    return (
        <>
            <PageTop
                title={title}
                icon="sprite-ce"
                breadcrumb={breadcrumb}
            />
            <div className="cp-order-invoices-feature cp-order-invoices-details">
                <Content />
            </div>
        </>
    );
};

const Content = (): JSX.Element => {
    const invoice = useInvoiceDetailsData();
    const { userAffList } = useAtomValue(cpOrderInvoicesDetailsPageStateAtom);

    return (
        <>
            <CpOrderInvoiceInformationPanel
                invoice={invoice}
                userAffList={userAffList}
            />
            <Panel>
                <CpOrderInvoiceLineItemsTableList />
            </Panel>
        </>
    );
};

export default PageOrdersCpOrderInvoicesDetails;
